import { useQuery } from '@tanstack/react-query'
import { transactionServices } from '../transactionServices'

interface UseGetTransactionParams {
  transactionId: string
  enabled?: boolean
}

export const useGetTransaction = ({
  transactionId,
  enabled = true,
}: UseGetTransactionParams) => {
  return useQuery({
    queryKey: ['transaction', transactionId],
    queryFn: () => transactionServices.getTransactionById(transactionId),
    enabled: enabled && !!transactionId,
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: false,
  })
}
